import { render, staticRenderFns } from "./Radar-Page.vue?vue&type=template&id=0a8e539a&"
import script from "./Radar-Page.vue?vue&type=script&lang=ts&"
export * from "./Radar-Page.vue?vue&type=script&lang=ts&"
import style0 from "./Radar-Page.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports